// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__e-7VR","sendOtp":"AuthorizeToLogin_sendOtp__1eveN"};